// extracted by mini-css-extract-plugin
export default {"contentContainer":"D4iSR___contentWidth-module__contentContainer","contentPadding":"jKUjC___contentWidth-module__contentPadding"};